import { WidgetRegistry, DefaultWidgetRegistry } from "ngx-schema-form"
import { CheckboxWidget } from './checkbox.widget'
import { RunButtonWidget } from './runButton.widget'
import { Injectable } from '@angular/core';
import { StringWidget } from './string.widget';
import { DateWidget } from './date.widget';

@Injectable()
export class WidgetRegistryCustom extends DefaultWidgetRegistry {
  constructor() {
    super();
    this.register('checkbox', CheckboxWidget);
    this.register('runButton', RunButtonWidget);
    this.register('string', StringWidget);
    this.register('date', DateWidget);
  }
}